const isMacintosh = () => {
    return navigator.platform.indexOf("Mac") > -1;
};
const isWindows = () => {
    return navigator.platform.indexOf("Win") > -1;
};
export const checkModifierKeyPressed = (event) => (isWindows() && event.ctrlKey) || (isMacintosh() && event.metaKey);
